import React from 'react';
export function Footer() {
  return <footer className="py-6 px-4 sm:px-6 bg-brand-taupe text-center text-brand-cream/60 text-[10px] sm:text-xs" data-id="element-67">
      <p className="leading-tight max-w-2xl mx-auto font-medium mb-3" data-id="element-68">
        © {new Date().getFullYear()} DANZA READY™ — Tutti i Diritti Riservati.
        Il contenuto di questa pagina ha scopo esclusivamente educativo e non
        sostituisce il consiglio professionale di un'insegnante di danza o di un
        medico. Segui sempre le linee guida di sicurezza appropriate e consulta
        un professionista della salute prima di iniziare qualsiasi programma di
        movimento.
      </p>
      <div className="flex justify-center gap-2 sm:gap-3 font-bold tracking-wide uppercase" data-id="element-69">
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-70">
          Termini e Condizioni
        </a>
        <span data-id="element-71">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-72">
          Privacy Policy
        </a>
        <span data-id="element-73">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-74">
          Contatto
        </a>
      </div>
    </footer>;
}